/**
 * Clair ou sombre : la règle de bascule d'un espace du design system, seule et testable.
 *
 * La préférence tranche : Clair et Sombre se passent du système, Automatique le suit. `systemScheme`
 * vaut `null` quand le système ne dit rien (web sans préférence, Android ancien) : on lit alors clair,
 * comme le reste de l'app. Chaque espace en tire son thème (`parentThemeFor`, `studentThemeFor`).
 */
export function isDarkFor(
    systemScheme: "light" | "dark" | null | undefined,
    preference: "auto" | "light" | "dark"
): boolean {
    if (preference === "auto") return systemScheme === "dark"
    return preference === "dark"
}
